var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Archivar Expediente " + _vm.processedFile.numero,
        centered: "",
        "hide-footer": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _vm._v(
          " Al dar por archivado este documento, no podrás actuar sobre él, ¿estás de acuerdo? "
        )
      ]),
      _c("div", { staticClass: "chip-custom" }, [
        _vm._v(
          " ¡Al realizar esta acción se marcará como archivado el expediente para todos los participantes y no se podrán hacer mas acciones sobre éste! "
        ),
        _c("br"),
        _c("b", [_vm._v("Esta acción no tiene vuelta atrás.")])
      ]),
      _c(
        "div",
        { staticClass: "wrap-commentary" },
        [
          _c("vs-textarea", {
            attrs: {
              "data-cy": "write-comment",
              maxlength: "255",
              label: "Comentario"
            },
            model: {
              value: _vm.comment,
              callback: function($$v) {
                _vm.comment = $$v
              },
              expression: "comment"
            }
          }),
          _vm.notValid
            ? _c("div", [
                _c("small", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    " No has ingresado un comentario para validar esta acción "
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "m-top-20",
          staticStyle: { display: "flex", "justify-content": "flex-end" }
        },
        [
          _c(
            "vs-button",
            {
              attrs: { "data-cy": "cancel", color: "dark", type: "border" },
              on: {
                click: function($event) {
                  return _vm.cancelProcess()
                }
              }
            },
            [_vm._v("Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticStyle: { "margin-left": "12px" },
              attrs: {
                "data-cy": "yes-archive",
                color: "primary",
                type: "border"
              },
              on: {
                click: function($event) {
                  return _vm.processFile()
                }
              }
            },
            [_vm._v(" Si, archivar ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }